import { memo } from 'react';
import { PageNavigator } from '@library';
import usePagination from '../../../hooks/usePagination';

const ListPagination = ({
    filteredTotal,
    pageSize,
}: {
    filteredTotal: number;
    pageSize: number;
}) => {
    const { page, updatePage } = usePagination();

    return (
        <PageNavigator
            autoScroll
            count={Math.ceil(filteredTotal / pageSize)}
            page={Number(page) || 1}
            onChange={updatePage}
        />
    );
};

export default memo(ListPagination);
